<template>
    <card-list-item @click="$emit('click')" :class="{'active': active}">
        <template v-slot:icon><i class="fa-fw fa-user" :class="{'fas': active, 'far': !active}"></i></template>
        <template v-slot:content>
            <div class="t-title">{{ applicant.users.last_name }}, {{ applicant.users.first_name }}</div>
            <div>
                <div class="meta" v-if="applicant.type === 'conf'"><i class="fas fa-presentation fa-fw mr-2"></i>{{applicant.conference.title}}</div>
            </div>
        </template>
        <template v-slot:status>
            <div class="stats">
                <span class="stat"><i class="fas fa-fw" :class="{'fa-check': applicant.completed_at, 'fa-exclamation-triangle': !applicant.completed_at}"></i></span>
            </div>
        </template>
        <template v-slot:details>
            <div class="tile-details">
                <div class="data mt-1">
                    <data-row mini title="Type">{{applicant.type.replace('conf', 'Conference') | capitalize}}</data-row>
                    <data-row mini title="Started">{{applicant.created_at | moment('MMMM Do YYYY, h:mm:ss a')}}</data-row>
                    <data-row mini title="Completed"><span v-if="applicant.completed_at">{{applicant.completed_at | moment('MMMM Do YYYY, h:mm:ss a')}}</span></data-row>
                    <data-row mini title="Minutes">{{applicant.total_minutes}}</data-row>
                    <data-row mini title="Units">{{applicant.total_units}}</data-row>
<!--                    <data-row mini title="Quoted Price">{{applicant.quoted_price | currency}}</data-row>-->
<!--                    <data-row mini title="Paid">{{applicant.total_paid | currency}}</data-row>-->

                    <!--                    <data-row mini title="Confirmation">{{ registration.code }}</data-row>-->
<!--                    <data-row mini title="Payment">-->
<!--                        <span v-if="registration.payment_type === 'cc'">{{registration.total_paid | currency}} by Credit Card</span>-->
<!--                        <span v-if="registration.payment_type === 'po'">{{registration.total_paid | currency}} by Purchase Order</span>-->
<!--                    </data-row>-->
                </div>
            </div>
        </template>
    </card-list-item>
</template>

<script>
    import Toolbar from "@/TIER/components/Toolbar";
    import DataRow from "@/TIER/components/DataRow";
    import CardListItem from "@/TIER/components/CardListItem";
    import moment from "moment";

    export default {
        name: 'ApplicantTile',
        components: {CardListItem, DataRow, Toolbar},
        props: {
            card: {
                required: true
            },
            applicant: {
                type: Object,
                required: true
            },
            active: {
                type: Boolean,
                default: false
            }
        },
        data: function() {
            return {};
        }
    };
</script>

<style lang="scss" scoped>
    @import '../../assets/variables';

    li {
        color: darken($t-primary, 18);
        padding: 0.5rem 0;

        .t-title {
            font-size: .9rem;
            font-weight: 700;
        }

        .tile-details {
            margin-top: 0.5rem;
        }

        .fa-exclamation-triangle {
            color: #e28c07;
        }

        .fa-check {
            color: green;
        }
    }
</style>
